import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import FeatureSection from './components/FeatureSection';
import VisionSection from './components/VisionSection';
import DesignSection from './components/DesignSection';
import  VideoSection from './components/VideoSection';
import  Footer from './components/Footer';


import './styles/index.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <FeatureSection />
      <DesignSection />
      <VideoSection />
      <VisionSection />
      <Footer />

    </div>
  );
}

export default App;